var Cr = Object.defineProperty;
var Lr = (n, a, s) => a in n ? Cr(n, a, { enumerable: !0, configurable: !0, writable: !0, value: s }) : n[a] = s;
var he = (n, a, s) => (Lr(n, typeof a != "symbol" ? a + "" : a, s), s);
import { jsx as T, jsxs as nt } from "react/jsx-runtime";
import { useRef as me, useEffect as Ie, useState as Or } from "react";
var _e = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function xr(n) {
  return n && n.__esModule && Object.prototype.hasOwnProperty.call(n, "default") ? n.default : n;
}
function Ir(n) {
  var a = me();
  return Ie(function() {
    a.current = n;
  }), a.current;
}
const Nr = {
  position: "absolute",
  top: 0,
  bottom: 0,
  left: 0,
  right: 0,
  display: "flex",
  alignItems: "center",
  justifyContent: "center",
  fontSize: "16px",
  fontFamily: "-apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', 'Oxygen', 'Ubuntu', 'Cantarell', 'Fira Sans', 'Droid Sans', 'Helvetica Neue', sans-serif"
}, Fr = {
  color: "#eaeaea",
  fontWeight: "bold",
  marginBottom: 0
}, jr = {
  color: "#bababa",
  marginBottom: 0
}, Br = {
  color: "#7a7a7a",
  fontSize: "smaller",
  marginTop: "1rem",
  marginBottom: 0
};
function $r(n) {
  const a = n.error || {
    message: "An unknown error occurred",
    messageSecondary: "Please refresh the page to try again.",
    code: "ERROR_BYTEARK_PLAYER_REACT_100000"
  };
  return /* @__PURE__ */ T("div", { style: Nr, children: /* @__PURE__ */ nt("div", { children: [
    /* @__PURE__ */ T("p", { style: Fr, children: a.message }),
    /* @__PURE__ */ T("p", { style: jr, children: a.messageSecondary }),
    /* @__PURE__ */ T("p", { style: Br, children: a.code })
  ] }) });
}
function Dr(n) {
  if (typeof n == "number")
    return n;
  if (typeof n != "string")
    return 0;
  const [a, s] = n.split(":").map(Number.parseFloat);
  return a === 0 || s === 0 ? 0 : s / a * 100;
}
function zr(n) {
  const a = n.playerProps, s = {
    position: "relative",
    width: "100%",
    minWidth: "100%",
    background: "#000000",
    backgroundImage: "none",
    backgroundSize: "cover",
    backgroundRepeat: "no-repeat"
  };
  if (a.fluid && (s.paddingTop = `${Dr(
    n.aspectRatio || "16:9"
  )}%`), !a.fluid && a.fill && (s.height = "100%", s.minHeight = "100%"), a.lazyload && !n.loaded && (s.position = "relative"), a.lazyload && n.loaded && (s.position = "absolute"), n.error)
    return /* @__PURE__ */ T("div", { className: n.className, style: s, children: /* @__PURE__ */ T($r, { error: n.error }) });
  a.poster && (s.backgroundImage = `url(${a.poster})`), s.cursor = "pointer";
  const o = {
    position: "absolute",
    width: "90px",
    top: "50%",
    left: "50%",
    marginTop: "-2.75em",
    marginLeft: "-2.75em",
    background: "rgba(0, 0, 0, 0.85)",
    borderRadius: "50%"
  }, f = {
    fill: "#FFF",
    transform: "translateX(13px) translateY(9px) scale(0.7)"
  }, c = a.controls === void 0 || a.controls === null || a.controls === !0;
  return /* @__PURE__ */ T(
    "div",
    {
      onClick: n.onClick,
      className: n.className,
      style: s,
      children: c ? /* @__PURE__ */ T(
        "svg",
        {
          className: "play-icon",
          width: "90",
          viewBox: "0 0 60 60",
          style: o,
          children: /* @__PURE__ */ T(
            "path",
            {
              style: f,
              d: "M47.43,27.26,14.11,5.87A3.34,3.34,0,0,0,9,8.79V51.56a3.34,3.34,0,0,0,5.11,2.91L47.43,33.09A3.49,3.49,0,0,0,47.43,27.26Z"
            }
          )
        }
      ) : null
    }
  );
}
const Mr = "https://byteark-sdk.cdn.byteark.com/player-core", Yr = "https://player.byteark.com/players", Ur = "v2", Gr = "byteark-player.min.js", Kr = "byteark-player.min.css";
function Hr() {
  const n = [
    "com.widevine.alpha",
    "com.apple.fps.3_0",
    "com.apple.fps.2_0",
    "com.apple.fps.1_0",
    "com.apple.fps"
  ], a = [
    { contentType: 'video/mp4; codecs="avc1.42E01E"' },
    { contentType: 'video/webm; codecs="vp8"' }
  ], f = [{
    videoCapabilities: a,
    persistentState: "required",
    sessionTypes: ["persistent-license"]
  }, {
    initDataTypes: ["cenc"],
    videoCapabilities: a
  }], c = {}, h = (E) => navigator.requestMediaKeySystemAccess(E, f).then(() => {
    c[E] = !0;
  }).catch(() => {
    c[E] = !1;
  }), P = n.map((E) => h(E));
  return Promise.all(P).then(() => {
    const E = c["com.widevine.alpha"] === !0, H = c["com.apple.fps.3_0"] === !0 || c["com.apple.fps.2_0"] === !0 || c["com.apple.fps.1_0"] === !0 || c["com.apple.fps"] === !0;
    return !E && !H ? Promise.reject(new Error("Browser does not support DRM")) : {
      widevine: E,
      fairplay: H
    };
  });
}
function qr(n) {
  return n.endsWith(".js") ? "script" : n.endsWith(".css") ? "style" : null;
}
function Wr(n, a) {
  return new Promise((s, o) => {
    const f = document.getElementsByTagName("head")[0], c = document.createElement("script");
    c.id = n, c.async = !1, c.src = a, c.addEventListener("load", () => {
      c.setAttribute("data-load-completed", `${(/* @__PURE__ */ new Date()).getTime()}`), s();
    }), c.addEventListener("error", (h) => {
      f.removeChild(c), o(h);
    }), f.appendChild(c);
  });
}
function Jr(n, a) {
  return new Promise((s, o) => {
    const f = document.getElementsByTagName("head")[0], c = document.createElement("link");
    c.id = n, c.setAttribute("rel", "stylesheet"), c.setAttribute("type", "text/css"), c.setAttribute("href", a), c.addEventListener("load", () => {
      c.setAttribute("data-load-completed", `${(/* @__PURE__ */ new Date()).getTime()}`), s();
    }), c.addEventListener("error", (h) => {
      f.removeChild(c), o(h);
    }), f.appendChild(c);
  });
}
function Xr(n) {
  return new Promise((a, s) => {
    n.getAttribute("data-load-completed") && a(), n.addEventListener("load", () => a()), n.addEventListener("error", (o) => s(o));
  });
}
function ne(n, a, s) {
  const o = document.getElementById(n);
  if (o)
    return Xr(o);
  switch (s || qr(a)) {
    case "script":
      return Wr(n, a);
    case "style":
      return Jr(n, a);
    default:
      return Promise.reject(new Error("Not supported resource type"));
  }
}
var we = { exports: {} };
we.exports;
(function(n, a) {
  var s = 200, o = "__lodash_hash_undefined__", f = 1, c = 2, h = 9007199254740991, P = "[object Arguments]", E = "[object Array]", H = "[object AsyncFunction]", y = "[object Boolean]", q = "[object Date]", S = "[object Error]", W = "[object Function]", Q = "[object GeneratorFunction]", x = "[object Map]", L = "[object Number]", be = "[object Null]", B = "[object Object]", ie = "[object Promise]", ve = "[object Proxy]", se = "[object RegExp]", J = "[object Set]", oe = "[object String]", Pe = "[object Symbol]", Ee = "[object Undefined]", X = "[object WeakMap]", u = "[object ArrayBuffer]", m = "[object DataView]", V = "[object Float32Array]", st = "[object Float64Array]", ot = "[object Int8Array]", lt = "[object Int16Array]", ct = "[object Int32Array]", ut = "[object Uint8Array]", ft = "[object Uint8ClampedArray]", dt = "[object Uint16Array]", pt = "[object Uint32Array]", yt = /[\\^$.*+?()[\]{}|]/g, gt = /^\[object .+?Constructor\]$/, ht = /^(?:0|[1-9]\d*)$/, d = {};
  d[V] = d[st] = d[ot] = d[lt] = d[ct] = d[ut] = d[ft] = d[dt] = d[pt] = !0, d[P] = d[E] = d[u] = d[y] = d[m] = d[q] = d[S] = d[W] = d[x] = d[L] = d[B] = d[se] = d[J] = d[oe] = d[X] = !1;
  var Ne = typeof _e == "object" && _e && _e.Object === Object && _e, _t = typeof self == "object" && self && self.Object === Object && self, N = Ne || _t || Function("return this")(), Fe = a && !a.nodeType && a, je = Fe && !0 && n && !n.nodeType && n, Be = je && je.exports === Fe, Se = Be && Ne.process, $e = function() {
    try {
      return Se && Se.binding && Se.binding("util");
    } catch {
    }
  }(), De = $e && $e.isTypedArray;
  function mt(e, t) {
    for (var r = -1, i = e == null ? 0 : e.length, p = 0, l = []; ++r < i; ) {
      var _ = e[r];
      t(_, r, e) && (l[p++] = _);
    }
    return l;
  }
  function wt(e, t) {
    for (var r = -1, i = t.length, p = e.length; ++r < i; )
      e[p + r] = t[r];
    return e;
  }
  function bt(e, t) {
    for (var r = -1, i = e == null ? 0 : e.length; ++r < i; )
      if (t(e[r], r, e))
        return !0;
    return !1;
  }
  function vt(e, t) {
    for (var r = -1, i = Array(e); ++r < e; )
      i[r] = t(r);
    return i;
  }
  function Pt(e) {
    return function(t) {
      return e(t);
    };
  }
  function Et(e, t) {
    return e.has(t);
  }
  function St(e, t) {
    return e == null ? void 0 : e[t];
  }
  function At(e) {
    var t = -1, r = Array(e.size);
    return e.forEach(function(i, p) {
      r[++t] = [p, i];
    }), r;
  }
  function Tt(e, t) {
    return function(r) {
      return e(t(r));
    };
  }
  function Rt(e) {
    var t = -1, r = Array(e.size);
    return e.forEach(function(i) {
      r[++t] = i;
    }), r;
  }
  var Ct = Array.prototype, Lt = Function.prototype, le = Object.prototype, Ae = N["__core-js_shared__"], ze = Lt.toString, I = le.hasOwnProperty, Me = function() {
    var e = /[^.]+$/.exec(Ae && Ae.keys && Ae.keys.IE_PROTO || "");
    return e ? "Symbol(src)_1." + e : "";
  }(), Ye = le.toString, Ot = RegExp(
    "^" + ze.call(I).replace(yt, "\\$&").replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, "$1.*?") + "$"
  ), Ue = Be ? N.Buffer : void 0, ce = N.Symbol, Ge = N.Uint8Array, Ke = le.propertyIsEnumerable, xt = Ct.splice, M = ce ? ce.toStringTag : void 0, He = Object.getOwnPropertySymbols, It = Ue ? Ue.isBuffer : void 0, Nt = Tt(Object.keys, Object), Te = Z(N, "DataView"), k = Z(N, "Map"), Re = Z(N, "Promise"), Ce = Z(N, "Set"), Le = Z(N, "WeakMap"), ee = Z(Object, "create"), Ft = G(Te), jt = G(k), Bt = G(Re), $t = G(Ce), Dt = G(Le), qe = ce ? ce.prototype : void 0, Oe = qe ? qe.valueOf : void 0;
  function Y(e) {
    var t = -1, r = e == null ? 0 : e.length;
    for (this.clear(); ++t < r; ) {
      var i = e[t];
      this.set(i[0], i[1]);
    }
  }
  function zt() {
    this.__data__ = ee ? ee(null) : {}, this.size = 0;
  }
  function Mt(e) {
    var t = this.has(e) && delete this.__data__[e];
    return this.size -= t ? 1 : 0, t;
  }
  function Yt(e) {
    var t = this.__data__;
    if (ee) {
      var r = t[e];
      return r === o ? void 0 : r;
    }
    return I.call(t, e) ? t[e] : void 0;
  }
  function Ut(e) {
    var t = this.__data__;
    return ee ? t[e] !== void 0 : I.call(t, e);
  }
  function Gt(e, t) {
    var r = this.__data__;
    return this.size += this.has(e) ? 0 : 1, r[e] = ee && t === void 0 ? o : t, this;
  }
  Y.prototype.clear = zt, Y.prototype.delete = Mt, Y.prototype.get = Yt, Y.prototype.has = Ut, Y.prototype.set = Gt;
  function F(e) {
    var t = -1, r = e == null ? 0 : e.length;
    for (this.clear(); ++t < r; ) {
      var i = e[t];
      this.set(i[0], i[1]);
    }
  }
  function Kt() {
    this.__data__ = [], this.size = 0;
  }
  function Ht(e) {
    var t = this.__data__, r = fe(t, e);
    if (r < 0)
      return !1;
    var i = t.length - 1;
    return r == i ? t.pop() : xt.call(t, r, 1), --this.size, !0;
  }
  function qt(e) {
    var t = this.__data__, r = fe(t, e);
    return r < 0 ? void 0 : t[r][1];
  }
  function Wt(e) {
    return fe(this.__data__, e) > -1;
  }
  function Jt(e, t) {
    var r = this.__data__, i = fe(r, e);
    return i < 0 ? (++this.size, r.push([e, t])) : r[i][1] = t, this;
  }
  F.prototype.clear = Kt, F.prototype.delete = Ht, F.prototype.get = qt, F.prototype.has = Wt, F.prototype.set = Jt;
  function U(e) {
    var t = -1, r = e == null ? 0 : e.length;
    for (this.clear(); ++t < r; ) {
      var i = e[t];
      this.set(i[0], i[1]);
    }
  }
  function Xt() {
    this.size = 0, this.__data__ = {
      hash: new Y(),
      map: new (k || F)(),
      string: new Y()
    };
  }
  function Zt(e) {
    var t = de(this, e).delete(e);
    return this.size -= t ? 1 : 0, t;
  }
  function Qt(e) {
    return de(this, e).get(e);
  }
  function Vt(e) {
    return de(this, e).has(e);
  }
  function kt(e, t) {
    var r = de(this, e), i = r.size;
    return r.set(e, t), this.size += r.size == i ? 0 : 1, this;
  }
  U.prototype.clear = Xt, U.prototype.delete = Zt, U.prototype.get = Qt, U.prototype.has = Vt, U.prototype.set = kt;
  function ue(e) {
    var t = -1, r = e == null ? 0 : e.length;
    for (this.__data__ = new U(); ++t < r; )
      this.add(e[t]);
  }
  function er(e) {
    return this.__data__.set(e, o), this;
  }
  function tr(e) {
    return this.__data__.has(e);
  }
  ue.prototype.add = ue.prototype.push = er, ue.prototype.has = tr;
  function $(e) {
    var t = this.__data__ = new F(e);
    this.size = t.size;
  }
  function rr() {
    this.__data__ = new F(), this.size = 0;
  }
  function nr(e) {
    var t = this.__data__, r = t.delete(e);
    return this.size = t.size, r;
  }
  function ar(e) {
    return this.__data__.get(e);
  }
  function ir(e) {
    return this.__data__.has(e);
  }
  function sr(e, t) {
    var r = this.__data__;
    if (r instanceof F) {
      var i = r.__data__;
      if (!k || i.length < s - 1)
        return i.push([e, t]), this.size = ++r.size, this;
      r = this.__data__ = new U(i);
    }
    return r.set(e, t), this.size = r.size, this;
  }
  $.prototype.clear = rr, $.prototype.delete = nr, $.prototype.get = ar, $.prototype.has = ir, $.prototype.set = sr;
  function or(e, t) {
    var r = pe(e), i = !r && Pr(e), p = !r && !i && xe(e), l = !r && !i && !p && tt(e), _ = r || i || p || l, w = _ ? vt(e.length, String) : [], b = w.length;
    for (var g in e)
      (t || I.call(e, g)) && !(_ && // Safari 9 has enumerable `arguments.length` in strict mode.
      (g == "length" || // Node.js 0.10 has enumerable non-index properties on buffers.
      p && (g == "offset" || g == "parent") || // PhantomJS 2 has enumerable non-index properties on typed arrays.
      l && (g == "buffer" || g == "byteLength" || g == "byteOffset") || // Skip index properties.
      _r(g, b))) && w.push(g);
    return w;
  }
  function fe(e, t) {
    for (var r = e.length; r--; )
      if (Qe(e[r][0], t))
        return r;
    return -1;
  }
  function lr(e, t, r) {
    var i = t(e);
    return pe(e) ? i : wt(i, r(e));
  }
  function te(e) {
    return e == null ? e === void 0 ? Ee : be : M && M in Object(e) ? gr(e) : vr(e);
  }
  function We(e) {
    return re(e) && te(e) == P;
  }
  function Je(e, t, r, i, p) {
    return e === t ? !0 : e == null || t == null || !re(e) && !re(t) ? e !== e && t !== t : cr(e, t, r, i, Je, p);
  }
  function cr(e, t, r, i, p, l) {
    var _ = pe(e), w = pe(t), b = _ ? E : D(e), g = w ? E : D(t);
    b = b == P ? B : b, g = g == P ? B : g;
    var A = b == B, O = g == B, v = b == g;
    if (v && xe(e)) {
      if (!xe(t))
        return !1;
      _ = !0, A = !1;
    }
    if (v && !A)
      return l || (l = new $()), _ || tt(e) ? Xe(e, t, r, i, p, l) : pr(e, t, b, r, i, p, l);
    if (!(r & f)) {
      var R = A && I.call(e, "__wrapped__"), C = O && I.call(t, "__wrapped__");
      if (R || C) {
        var z = R ? e.value() : e, j = C ? t.value() : t;
        return l || (l = new $()), p(z, j, r, i, l);
      }
    }
    return v ? (l || (l = new $()), yr(e, t, r, i, p, l)) : !1;
  }
  function ur(e) {
    if (!et(e) || wr(e))
      return !1;
    var t = Ve(e) ? Ot : gt;
    return t.test(G(e));
  }
  function fr(e) {
    return re(e) && ke(e.length) && !!d[te(e)];
  }
  function dr(e) {
    if (!br(e))
      return Nt(e);
    var t = [];
    for (var r in Object(e))
      I.call(e, r) && r != "constructor" && t.push(r);
    return t;
  }
  function Xe(e, t, r, i, p, l) {
    var _ = r & f, w = e.length, b = t.length;
    if (w != b && !(_ && b > w))
      return !1;
    var g = l.get(e);
    if (g && l.get(t))
      return g == t;
    var A = -1, O = !0, v = r & c ? new ue() : void 0;
    for (l.set(e, t), l.set(t, e); ++A < w; ) {
      var R = e[A], C = t[A];
      if (i)
        var z = _ ? i(C, R, A, t, e, l) : i(R, C, A, e, t, l);
      if (z !== void 0) {
        if (z)
          continue;
        O = !1;
        break;
      }
      if (v) {
        if (!bt(t, function(j, K) {
          if (!Et(v, K) && (R === j || p(R, j, r, i, l)))
            return v.push(K);
        })) {
          O = !1;
          break;
        }
      } else if (!(R === C || p(R, C, r, i, l))) {
        O = !1;
        break;
      }
    }
    return l.delete(e), l.delete(t), O;
  }
  function pr(e, t, r, i, p, l, _) {
    switch (r) {
      case m:
        if (e.byteLength != t.byteLength || e.byteOffset != t.byteOffset)
          return !1;
        e = e.buffer, t = t.buffer;
      case u:
        return !(e.byteLength != t.byteLength || !l(new Ge(e), new Ge(t)));
      case y:
      case q:
      case L:
        return Qe(+e, +t);
      case S:
        return e.name == t.name && e.message == t.message;
      case se:
      case oe:
        return e == t + "";
      case x:
        var w = At;
      case J:
        var b = i & f;
        if (w || (w = Rt), e.size != t.size && !b)
          return !1;
        var g = _.get(e);
        if (g)
          return g == t;
        i |= c, _.set(e, t);
        var A = Xe(w(e), w(t), i, p, l, _);
        return _.delete(e), A;
      case Pe:
        if (Oe)
          return Oe.call(e) == Oe.call(t);
    }
    return !1;
  }
  function yr(e, t, r, i, p, l) {
    var _ = r & f, w = Ze(e), b = w.length, g = Ze(t), A = g.length;
    if (b != A && !_)
      return !1;
    for (var O = b; O--; ) {
      var v = w[O];
      if (!(_ ? v in t : I.call(t, v)))
        return !1;
    }
    var R = l.get(e);
    if (R && l.get(t))
      return R == t;
    var C = !0;
    l.set(e, t), l.set(t, e);
    for (var z = _; ++O < b; ) {
      v = w[O];
      var j = e[v], K = t[v];
      if (i)
        var rt = _ ? i(K, j, v, t, e, l) : i(j, K, v, e, t, l);
      if (!(rt === void 0 ? j === K || p(j, K, r, i, l) : rt)) {
        C = !1;
        break;
      }
      z || (z = v == "constructor");
    }
    if (C && !z) {
      var ye = e.constructor, ge = t.constructor;
      ye != ge && "constructor" in e && "constructor" in t && !(typeof ye == "function" && ye instanceof ye && typeof ge == "function" && ge instanceof ge) && (C = !1);
    }
    return l.delete(e), l.delete(t), C;
  }
  function Ze(e) {
    return lr(e, Ar, hr);
  }
  function de(e, t) {
    var r = e.__data__;
    return mr(t) ? r[typeof t == "string" ? "string" : "hash"] : r.map;
  }
  function Z(e, t) {
    var r = St(e, t);
    return ur(r) ? r : void 0;
  }
  function gr(e) {
    var t = I.call(e, M), r = e[M];
    try {
      e[M] = void 0;
      var i = !0;
    } catch {
    }
    var p = Ye.call(e);
    return i && (t ? e[M] = r : delete e[M]), p;
  }
  var hr = He ? function(e) {
    return e == null ? [] : (e = Object(e), mt(He(e), function(t) {
      return Ke.call(e, t);
    }));
  } : Tr, D = te;
  (Te && D(new Te(new ArrayBuffer(1))) != m || k && D(new k()) != x || Re && D(Re.resolve()) != ie || Ce && D(new Ce()) != J || Le && D(new Le()) != X) && (D = function(e) {
    var t = te(e), r = t == B ? e.constructor : void 0, i = r ? G(r) : "";
    if (i)
      switch (i) {
        case Ft:
          return m;
        case jt:
          return x;
        case Bt:
          return ie;
        case $t:
          return J;
        case Dt:
          return X;
      }
    return t;
  });
  function _r(e, t) {
    return t = t ?? h, !!t && (typeof e == "number" || ht.test(e)) && e > -1 && e % 1 == 0 && e < t;
  }
  function mr(e) {
    var t = typeof e;
    return t == "string" || t == "number" || t == "symbol" || t == "boolean" ? e !== "__proto__" : e === null;
  }
  function wr(e) {
    return !!Me && Me in e;
  }
  function br(e) {
    var t = e && e.constructor, r = typeof t == "function" && t.prototype || le;
    return e === r;
  }
  function vr(e) {
    return Ye.call(e);
  }
  function G(e) {
    if (e != null) {
      try {
        return ze.call(e);
      } catch {
      }
      try {
        return e + "";
      } catch {
      }
    }
    return "";
  }
  function Qe(e, t) {
    return e === t || e !== e && t !== t;
  }
  var Pr = We(/* @__PURE__ */ function() {
    return arguments;
  }()) ? We : function(e) {
    return re(e) && I.call(e, "callee") && !Ke.call(e, "callee");
  }, pe = Array.isArray;
  function Er(e) {
    return e != null && ke(e.length) && !Ve(e);
  }
  var xe = It || Rr;
  function Sr(e, t) {
    return Je(e, t);
  }
  function Ve(e) {
    if (!et(e))
      return !1;
    var t = te(e);
    return t == W || t == Q || t == H || t == ve;
  }
  function ke(e) {
    return typeof e == "number" && e > -1 && e % 1 == 0 && e <= h;
  }
  function et(e) {
    var t = typeof e;
    return e != null && (t == "object" || t == "function");
  }
  function re(e) {
    return e != null && typeof e == "object";
  }
  var tt = De ? Pt(De) : fr;
  function Ar(e) {
    return Er(e) ? or(e) : dr(e);
  }
  function Tr() {
    return [];
  }
  function Rr() {
    return !1;
  }
  n.exports = Sr;
})(we, we.exports);
var Zr = we.exports;
const Qr = /* @__PURE__ */ xr(Zr), Vr = [
  {
    name: "autoplay"
  },
  {
    name: "aspectRatio"
  },
  {
    name: "breakpoints"
  },
  {
    name: "controls"
  },
  {
    name: "fill"
  },
  {
    name: "fluid"
  },
  {
    name: "loop"
  },
  {
    name: "language"
  },
  {
    name: "muted"
  },
  {
    name: "playbackRates"
  },
  {
    name: "playsinline"
  },
  {
    name: "poster"
  },
  {
    name: "preload"
  },
  {
    name: "responsive"
  },
  {
    name: "sources",
    setter: "src"
  }
];
function kr(n, a, s) {
  n.isDisposed() || Vr.forEach(({ name: o, setter: f }) => {
    const h = n[f || o];
    typeof h == "function" && (s && Qr(a[o], s[o]) || h.call(n, a[o]));
  });
}
const en = (n, a, s) => window.bytearkPlayer.initAsync ? window.bytearkPlayer.initAsync(n, a, s) : window.bytearkPlayer.init(n, a, s), tn = async (n, a, s) => {
  await window.bytearkPlayer.setup(n, a, s);
};
class ae extends Error {
  constructor(s, o, f, c, h) {
    super(f);
    he(this, "code");
    he(this, "originalError");
    he(this, "messageSecondary");
    this.name = s, this.code = o, this.originalError = c, this.messageSecondary = h || "Please refresh the page to try again.";
  }
}
class at extends ae {
  constructor(a, s, o) {
    super(
      "LoadPlayerResourceError",
      "ERROR_BYTEARK_PLAYER_REACT_100001",
      a,
      s,
      o
    );
  }
}
class it extends ae {
  constructor(a, s, o) {
    super(
      "SetupPlayerOptionsError",
      "ERROR_BYTEARK_PLAYER_REACT_100002",
      a,
      s,
      o
    );
  }
}
class rn extends ae {
  constructor(a, s, o) {
    super(
      "SetupPlayerError",
      "ERROR_BYTEARK_PLAYER_REACT_100003",
      a,
      s,
      o
    );
  }
}
class nn extends ae {
  constructor(a, s, o) {
    super(
      "CreatePlayerError",
      "ERROR_BYTEARK_PLAYER_REACT_100004",
      a,
      s,
      o
    );
  }
}
async function an(n) {
  try {
    const {
      playerJsFileName: a,
      playerCssFileName: s,
      playerVersion: o,
      playerEndpoint: f,
      playerServerEndpoint: c,
      playerSlugId: h
    } = n, P = [];
    h ? (a && P.push(
      ne(
        `byteark-player-script-${h}`,
        `${c}/${h}/libraries/${a}`,
        "script"
      )
    ), s && P.push(
      ne(
        `byteark-player-style-${h}`,
        `${c}/${h}/libraries/${s}`,
        "style"
      )
    )) : (a && P.push(
      ne(
        `byteark-player-script-${o}`,
        `${f}/${o}/${a}`,
        "script"
      )
    ), s && P.push(
      ne(
        `byteark-player-style-${o}`,
        `${f}/${o}/${s}`,
        "style"
      )
    )), await Promise.all(P);
  } catch (a) {
    throw new at("Failed to load player resources", a);
  }
}
async function sn(n) {
  try {
    const a = await window.bytearkPlayer.canAutoplay(n);
    return {
      ...n,
      autoplayResult_: a
    };
  } catch (a) {
    throw new it("Failed to setup player options", a);
  }
}
async function on(n, a) {
  try {
    await a(n, ne);
  } catch (s) {
    throw new rn("Failed to setup player", s);
  }
}
async function ln(n, a, s, o) {
  if (n === null)
    return null;
  window.bytearkPlayer = window.bytearkPlayer || {}, window.bytearkPlayer.isBrowserSupportDrm = Hr;
  try {
    return await s(n, a, o);
  } catch (f) {
    throw new nn("Failed to create player instance", f);
  }
}
function cn() {
  return typeof window < "u" && window.document && window.document.createElement !== void 0;
}
window.bytearkPlayer = window.bytearkPlayer || {};
const un = (n, a, s) => /* @__PURE__ */ T(
  zr,
  {
    aspectRatio: n.aspectRatio,
    onClick: s,
    className: n.className,
    error: a.error,
    loaded: a.loaded,
    playerProps: n
  }
);
function yn(n) {
  const {
    createPlaceholderFunction: a = un,
    createPlayerFunction: s = en,
    lazyload: o = !1,
    playerEndpoint: f = Mr,
    playerServerEndpoint: c = Yr,
    playerVersion: h = Ur,
    playerJsFileName: P = Gr,
    playerCssFileName: E = Kr,
    setupPlayerFunction: H = tn,
    ...y
  } = n, q = Ir(n), S = me(null), W = me(!1), Q = me(null), [x, L] = Or({
    loaded: !1,
    ready: !1,
    error: null,
    showPlaceholder: !0
  }), be = () => {
    y.onPlayerLoaded && y.onPlayerLoaded();
  }, B = (u, m) => {
    L((V) => ({ ...V, error: u })), y.onPlayerLoadError && y.onPlayerLoadError(u, m);
  }, ie = () => {
    L((u) => ({ ...u, loaded: !0 })), y.onPlayerSetup && y.onPlayerSetup();
  }, ve = (u, m) => {
    L((V) => ({ ...V, error: u })), y.onPlayerSetupError && y.onPlayerSetupError(u, m);
  }, se = () => {
    L((u) => ({
      ...u,
      showPlaceholder: !1
    })), S.current && y.onPlayerCreated && y.onPlayerCreated(S.current);
  }, J = () => {
    L((u) => ({ ...u, ready: !0 })), S.current && y.onReady && y.onReady(S.current);
  }, oe = async () => {
    var u;
    o && (await X(), await ((u = S.current) == null ? void 0 : u.play())), L((m) => ({
      ...m,
      showPlaceholder: !1
    }));
  }, Pe = () => a(
    n,
    {
      error: x.error,
      loaded: x.loaded
    },
    oe
  ), Ee = () => {
    const u = {}, m = [];
    return y.className && m.push(y.className), y.fluid && (y.aspectRatio === "4:3" ? m.push("vjs-4-3") : y.aspectRatio === "16:9" && m.push("vjs-16-9")), y.audioOnlyMode ? /* @__PURE__ */ T(
      "audio",
      {
        ref: Q,
        className: `video-js ${y.className}`,
        style: u
      }
    ) : /* @__PURE__ */ T(
      "video",
      {
        playsInline: !0,
        ref: Q,
        className: `video-js ${m.join(" ")}`,
        style: u
      }
    );
  }, X = async () => {
    if (cn() && !W.current) {
      W.current = !0;
      try {
        await an({
          playerJsFileName: P,
          playerCssFileName: E,
          playerVersion: h,
          playerEndpoint: f,
          playerServerEndpoint: c,
          playerSlugId: y.playerSlugId
        }), be();
        const u = await sn(n);
        await on(u, H), ie(), S.current = await ln(
          Q.current,
          u,
          s,
          J
        ), se();
      } catch (u) {
        u instanceof at ? ve(u, u.originalError) : u instanceof it ? B(u, u.originalError) : u instanceof ae && L((m) => ({
          ...m,
          error: u
        })), console.error(u);
      } finally {
        W.current = !1;
      }
    }
  };
  return Ie(() => ((async () => {
    o || await X();
  })(), () => {
    S.current && (S.current.dispose(), S.current = null, L((m) => ({ ...m, ready: !1 })));
  }), []), Ie(() => {
    S.current && n && q && kr(S.current, n, q);
  }, [n, q]), /* @__PURE__ */ nt("div", { style: { position: "relative", height: "100%" }, children: [
    x.showPlaceholder && Pe(),
    /* @__PURE__ */ T(
      "div",
      {
        style: {
          display: x.showPlaceholder ? "none" : "initial"
        },
        children: x.error === null && Ee()
      }
    )
  ] });
}
export {
  yn as ByteArkPlayerContainer,
  Hr as isBrowserSupportDrm
};
